import { FunctionComponent } from 'react';

import { Field, Widget } from '@kanda-libs/ks-component-ts';

import SatNoteAddressFields from './AddressFIelds';
import {
  COMPLETE_INPUT_INTRO_PROPS,
  COMPLETE_INPUT_VALIDATION,
  INPUT_PROPS,
  INTRO_PROPS,
} from './constants';

const SatNoteFormQuestionsIntroduced: FunctionComponent = () => (
  <>
    <Field.Validator validation={COMPLETE_INPUT_VALIDATION}>
      <Field.Select {...COMPLETE_INPUT_INTRO_PROPS} />
    </Field.Validator>
    <Widget.JobSatNoteQPressure {...INPUT_PROPS} {...INTRO_PROPS.pressure} />
    <Widget.JobSatNoteQEasiness {...INPUT_PROPS} {...INTRO_PROPS.easiness} />
    <Widget.JobSatNoteQAvailability
      {...INPUT_PROPS}
      {...INTRO_PROPS.availability}
    />
    <Widget.JobSatNoteQApplication
      {...INPUT_PROPS}
      {...INTRO_PROPS.application}
    />
    <Widget.JobSatNoteQAdvice {...INPUT_PROPS} {...INTRO_PROPS.advice} />
    <SatNoteAddressFields />
    <Field.FingerprintBooleanInput
      handle="checkbox"
      name="acknowledged"
      fieldText="I acknowledge that by clicking the submit button I agree the initial delivery* has been made and is to my satisfaction."
    />
  </>
);

export default SatNoteFormQuestionsIntroduced;
